import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const ProductCard = ({ product, onAddToCart }) => {
  const [showModal, setShowModal] = useState(false);
  const defaultImage =
    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"; // 🔹 Gambar default jika tidak ada

  function convertToK(number) {
    if (number >= 1000) {
      return (number / 1000).toFixed(1) + "k"; // Membagi dengan 1000 dan menambahkan 'k'
    }
    return number.toString(); // Jika angka kurang dari 1000, tidak diubah
  }

  // Contoh penggunaan:
  // console.log(convertToK(1000)); // "1.0k"
  // console.log(convertToK(500)); // "500"
  // console.log(convertToK(2500)); // "2.5k"
  // console.log(convertToK(1200000)); // "1200.0k"

  return (
    <div
      className="card p-2 m-1 d-flex flex-column align-items-center position-relative"
      style={{ width: "180px", height: "200px", cursor: "pointer" }}
      onClick={() => onAddToCart(product)}
    >
      {/* 🔹 Tax Badge */}
      {product.tax_percent > 0 && (
        <div
          className="position-absolute badge bg-red-lt m-1"
          style={{ 
            top: "5px", 
            left: "5px", 
            zIndex: 1,
          }}
        >
          Tax {Math.floor(product.tax_percent)}%
        </div>
      )}

      {/* 🔹 Gambar Produk */}
      <div style={{ width: "100%", height: "120px", overflow: "hidden" }}>
        <img
          src={product.menu_url || defaultImage} // ✅ Gunakan gambar default jika `product.image` kosong
          className="card-img-top"
          alt={product.name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
      {/* Tombol "Detail" */}
      <button
        className="btn btn-sm btn-info position-absolute"
        style={{ top: "5px", right: "5px" }}
        onClick={(e) => {
          e.stopPropagation(); // Mencegah klik pada kartu menambah ke keranjang
          setShowModal(true);
        }}
      >
        {/* <IconHelpOctagon /> */}
        {/* stock */}
        {product.total_stock}
      </button>

      {/* Nama Produk & Harga */}
      <div className="card-body text-center p-1" style={{ flexGrow: 1 }}>
        <h6 className="card-title mb-1">{product.name}</h6>
        <p className="text-muted small">Rp {convertToK(product.price)}</p>
      </div>

      {/* Modal untuk Detail Produk */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="modal-blur"
      >
        <Modal.Header closeButton>
          <Modal.Title>{product.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <p>
            <strong>Deskripsi:</strong> {product.description}
          </p>
          <p>
            <strong>Bahan:</strong> {product.ingredients?.join(", ")}
          </p> */}
          <img
            src={product.menu_url || defaultImage}
            alt={product.name}
            className="img-fluid mb-3"
            style={{ objectFit: "cover" }}
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowModal(false)}
          >
            Tutup
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductCard;
